var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-item',{staticClass:"settings-item-wrapper"},[_c('q-item-section',{staticClass:"full-width"},[_c('q-input',{attrs:{"outlined":"","label":_vm.item.text,"name":_vm.item.text,"hint":'Please enter external ID'},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }